(function () {
  function initQuoteForm(form) {
    if (form.dataset.llQuoteReady === 'true') return;
    form.dataset.llQuoteReady = 'true';

    var files = form.querySelector('[name="bestanden"]');
    var status = form.querySelector('[data-ll-quote-status]');
    var submit = form.querySelector('[data-ll-quote-submit]');

    function clearError(field) {
      field.setCustomValidity('');
      field.removeAttribute('aria-invalid');
      var error = document.getElementById(field.id + '-error');
      if (error) error.remove();
      var describedBy = (field.getAttribute('aria-describedby') || '').split(' ').filter(function (id) {
        return id && id !== field.id + '-error';
      });
      if (describedBy.length) field.setAttribute('aria-describedby', describedBy.join(' '));
      else field.removeAttribute('aria-describedby');
    }

    function showError(field) {
      field.setAttribute('aria-invalid', 'true');
      var error = document.createElement('small');
      error.id = field.id + '-error';
      error.className = 'll-quote-form__error';
      error.textContent = field.validationMessage;
      field.parentNode.appendChild(error);
      field.setAttribute('aria-describedby', ((field.getAttribute('aria-describedby') || '') + ' ' + error.id).trim());
    }

    function validateField(field) {
      clearError(field);
      if (field.required && !field.value.trim()) field.setCustomValidity('Vul dit veld in.');
      else if (field.type === 'email' && field.validity.typeMismatch) field.setCustomValidity('Vul een geldig e-mailadres in, bijvoorbeeld naam@bedrijf.nl.');

      if (field !== files) return;
      var selected = Array.prototype.slice.call(files.files || []);
      var allowedExtensions = /\.(ai|eps|dxf|pdf|jpe?g|png|webp)$/i;
      if (selected.length > 10) files.setCustomValidity('Kies maximaal 10 bestanden.');
      else if (selected.some(function (file) { return !allowedExtensions.test(file.name); })) files.setCustomValidity('Kies AI-, EPS-, DXF-, PDF-, JPG-, PNG- of WebP-bestanden.');
      else if (selected.some(function (file) { return file.size === 0 || file.size > 20 * 1024 * 1024; })) files.setCustomValidity('Elk bestand moet inhoud hebben en mag maximaal 20 MB groot zijn.');
      else if (selected.reduce(function (total, file) { return total + file.size; }, 0) > 50 * 1024 * 1024) files.setCustomValidity('De bestanden mogen samen maximaal 50 MB groot zijn.');
    }

    Array.prototype.forEach.call(form.querySelectorAll('input:not([type="hidden"]), select, textarea'), function (field) {
      field.addEventListener('input', function () {
        validateField(field);
        if (!field.validity.valid) showError(field);
      });
    });

    if (files) files.addEventListener('change', function () {
      validateField(files);
      if (!files.validity.valid) showError(files);
    });

    form.addEventListener('submit', function (event) {
      var invalid = null;
      Array.prototype.forEach.call(form.querySelectorAll('input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled)'), function (field) {
        validateField(field);
        if (!field.validity.valid) {
          showError(field);
          if (!invalid) invalid = field;
        }
      });
      if (invalid) {
        event.preventDefault();
        status.textContent = 'Controleer de gemarkeerde velden.';
        status.dataset.state = 'error';
        invalid.focus();
        return;
      }
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
    });
  }

  function showResult() {
    var target = window.location.hash;
    if (target !== '#aanvraag-ontvangen' && target !== '#aanvraag-fout') return;
    var notice = document.querySelector(target);
    var form = document.querySelector('.ll-quote-form__form');
    if (target === '#aanvraag-ontvangen' && form) form.hidden = true;
    if (notice) notice.focus();
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.ll-quote-form__form'), initQuoteForm);
    showResult();
  });
})();
